import { render, staticRenderFns } from "./time_sale_setting_edit.vue?vue&type=template&id=36633f1e&"
import script from "./time_sale_setting_edit.vue?vue&type=script&lang=ts&"
export * from "./time_sale_setting_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports